import { Accordion, Text } from '@medly-components/core';
import { KeyboardArrowRightIcon } from '@medly-components/icons';
import { memo, type FC } from 'react';

import { useSideNavContext } from 'context';
import NavItem from '../NavItem';
import { useSideNavHoverContext } from '../SideNav.context';
import { NavLink } from '../types';
import { SubNavListHeaderIcon, SubNavListWrapper } from './SubNavList.styled';

export const SubNavList: FC<NavLink> = memo(props => {
    const { isActive, title, subNavLinks, icon, expandSidenav } = props;
    const isHovered = useSideNavHoverContext();
    const { isExpanded } = useSideNavContext();

    return (
        <SubNavListWrapper isHovered={isHovered} isExpanded={isExpanded}>
            <Accordion defaultActive={isActive}>
                <Accordion.Header>
                    <SubNavListHeaderIcon data-testid={title} onClick={expandSidenav}>
                        {icon}
                    </SubNavListHeaderIcon>
                    <Text>{title}</Text>
                </Accordion.Header>
                <Accordion.Content as="ul">
                    {subNavLinks?.map(link => (
                        <NavItem title={link.title} path={link.path} key={link.title} isActive={link.isActive} onClick={link.onClick}>
                            <Text textVariant="body1">{link.title}</Text>
                            {link.externalExpand ? <KeyboardArrowRightIcon style={{ marginLeft: 'auto' }} /> : null}
                        </NavItem>
                    ))}
                </Accordion.Content>
            </Accordion>
        </SubNavListWrapper>
    );
});
SubNavList.displayName = 'SubNavList';
